import React from "react";
import './LeichterKorrosionsschutz.css';
import { useNavigate } from 'react-router-dom';




const LeichterKorrosionsschutz = () => {

    const navigate = useNavigate();
    const handleNavigationContact = () => {
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById('contact');
          if ( element ){
            element.scrollIntoView({behavior: 'smooth'});
          }
        }, 100);
    }



    return(
        <section className="korrosionsschutz-container">
            <h1 className="korrosionsschutz-title">Effiziente Lösungen für dauerhaften Oberflächenschutz</h1>
            <p className="korrosionsschutz-description">Praktische Strategien und moderne Materialien für den langfristigen Schutz empfindlicher Oberflächen</p>
            
            
            <section className="korrosionsschutz-dienstleistungen">
                <h2>Unsere Dienstleistungen</h2>
                <ul>
                    <li>Hochwertige Korrosionsschutzbeschichtungen</li>
                    <li>Beratung und Planung individueller Schutzmaßnahmen</li>
                    <li>Professionelle Inspektion und Wartung</li>
                    <li>Umweltfreundliche und nachhaltige Lösungen</li>
                </ul>
            </section>

            <section className="korrosionschutz-grund">
                <h2>Warum Korrosionsschutz wichtig ist:</h2>
                <p>
                    Korrosion kann nicht nur das Aussehen, sondern auch die Funktionalität von Materialien beeinträchtigen. 
                    Ein guter Korrosionsschutz verlängert die Lebensdauer von Metallen und Strukturen, senkt die Wartungskosten und trägt zur Sicherheit bei.
                </p>
            </section>

            <section className="korrosionsschutz-contact">
            <div className="tankreinigung-contact">
                <p>Kontaktieren Sie uns für eine unverbindliche Beratung und erfahren Sie mehr über unsere maßgeschneiderten Korrosionsschutzlösungen.</p>
                <button className="contact-button" onClick={handleNavigationContact}>Kontakt aufnehmen</button>
            </div>
            </section>
        </section>    
    );

};

export default LeichterKorrosionsschutz;